import React, { memo } from "react";
import useDevicesInfoCharts from "./index.hooks";
import { ResponsivePie } from "@nivo/pie";
import { ResponsiveBar } from "@nivo/bar";
import { Grid, Typography } from "@material-ui/core";
import { AppPaper } from "../index";

type DevicesInfoChartsProps = {};

const DevicesInfoCharts = ({}: DevicesInfoChartsProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    osDataMemo,
    manufacturerDataMemo,
    androidVersionDataMemo,
    iOSVersionDataMemo,
  } = useDevicesInfoCharts();

  //console.log(osDataMemo);
  //console.log(manufacturerDataMemo);
  //console.log(androidVersionDataMemo);
  //console.log(iOSVersionDataMemo);

  return (
    <Grid container>
      <Grid item className={styles.chartContainer}>
        <AppPaper className={styles.chartPaper}>
          <Typography>OS</Typography>
          <ResponsivePie
            data={osDataMemo}
            valueFormat=" <-.0%"
            margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
            innerRadius={0.55}
            padAngle={0.7}
            cornerRadius={3}
            activeOuterRadiusOffset={12}
          />
        </AppPaper>
      </Grid>
      <Grid item className={styles.chartContainer}>
        <AppPaper className={styles.chartPaper}>
          <Typography>Manufacturer</Typography>
          <ResponsivePie
            data={manufacturerDataMemo}
            valueFormat=" <-.0%"
            margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
            innerRadius={0.55}
            padAngle={0.7}
            cornerRadius={3}
            activeOuterRadiusOffset={12}
          />
        </AppPaper>
      </Grid>
      <Grid item className={styles.chartContainer}>
        <AppPaper className={styles.chartPaper}>
          <Typography>Android Version</Typography>
          <ResponsiveBar
            data={androidVersionDataMemo}
            indexBy="id"
            groupMode="grouped"
            margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
          />
        </AppPaper>
      </Grid>
      <Grid item className={styles.chartContainer}>
        <AppPaper className={styles.chartPaper}>
          <Typography>iOS version</Typography>
          <ResponsiveBar
            data={iOSVersionDataMemo}
            indexBy="id"
            groupMode="grouped"
            margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
          />
        </AppPaper>
      </Grid>
    </Grid>
  );
};

export default memo(DevicesInfoCharts);
